import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { CONTACT } from "@/data/catalog";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-background" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mono-label mt-6 text-primary">Waffenfachhandel · Mureck, AT</p>
            <address className="mt-4 not-italic font-body text-muted-foreground">
              {CONTACT.name}
              <br />
              {CONTACT.street}
              <br />
              {CONTACT.city}, {CONTACT.country}
            </address>
            <a href={`tel:${CONTACT.phoneHref}`} className="mt-4 block font-mono-t text-foreground hover:text-primary" data-testid="footer-phone">
              {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="block font-mono-t text-foreground hover:text-primary" data-testid="footer-email">
              {CONTACT.email}
            </a>
          </div>

          <div>
            <p className="mono-label text-muted-foreground">Sortiment</p>
            <ul className="mt-4 space-y-2 font-body">
              <li><Link to="/waffen" className="text-foreground hover:text-primary" data-testid="footer-link-waffen">Waffen</Link></li>
              <li><Link to="/munition" className="text-foreground hover:text-primary" data-testid="footer-link-munition">Munition</Link></li>
              <li><Link to="/zubehoer" className="text-foreground hover:text-primary" data-testid="footer-link-zubehoer">Zubehör</Link></li>
              <li><Link to="/fachhandel" className="text-foreground hover:text-primary" data-testid="footer-link-fachhandel">Fachhandel</Link></li>
            </ul>
          </div>

          <div>
            <p className="mono-label text-muted-foreground">Service</p>
            <ul className="mt-4 space-y-2 font-body">
              <li><Link to="/kontakt" className="text-foreground hover:text-primary" data-testid="footer-link-kontakt">Anfrage stellen</Link></li>
              <li><span className="text-muted-foreground">Dealer-Login</span></li>
              <li><Link to="/impressum" className="text-foreground hover:text-primary" data-testid="footer-link-impressum">Impressum</Link></li>
              <li><Link to="/datenschutz" className="text-foreground hover:text-primary" data-testid="footer-link-datenschutz">Datenschutz</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div className="overflow-hidden border-t border-border">
        <p className="select-none whitespace-nowrap px-5 py-6 font-display text-[16vw] font-700 uppercase leading-none tracking-tighter text-card">
          IMPEXMILTRADE
        </p>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col justify-between gap-2 px-5 py-5 sm:flex-row">
          <p className="mono-label text-muted-foreground">© {new Date().getFullYear()} Impexmiltrade GmbH</p>
          <p className="mono-label text-muted-foreground">§ Waffenhandel gem. österr. WaffG · Nur an Berechtigte</p>
        </div>
      </div>
    </footer>
  );
}
